import * as React from "react";
import {Redirect, Route} from "react-router";
import SignIn from "./container/SignIn";
import {PrivateRoute, PrivateRouteProps} from "./components/PrivateRoute";
import LoginForm from "./components/LoginForm";
import ReactGA from "react-ga";
import ReactGA4 from "react-ga4";
import {history} from "./redux/configure";
import {setCookie} from "./utils/common";
import OpenDentalUsers from "./components/OpenDentalUsers";
import CreateOpenDentalUser from "./components/CreateOpenDentalUser";
import UsageReport from "./components/UsageReport";
import ManualApiModule from "./components/ManualApiModule";
import UpdateBulkUser from "./components/UpdateBulkUser";
import UpdateBulkProviders from "./components/UpdateBulkProviders";
import OdAdjustments from "./components/OdAdjustments";
import OdPaymentTypes from "./components/OdPaymentTypes";
import OdFeeSchedules from "./components/OdFeeSchedules";
import OdInsPlansUcr from "./components/OdInsPlansUcr";
import ResetPassword from "./components/ResetPassword";

const isDevelopment = process.env.NODE_ENV === "development";

function AppRoutes(props: any) {
    const isAuthenticated = !!(props.auth && props.auth.user && props.auth.user.id);
    const defaultProtectedRouteProps: PrivateRouteProps = {
        isAuthenticated: isAuthenticated,
        authenticationPath: "/"
    };


    history.listen(() => {
        ReactGA.pageview(history.location.pathname + history.location.search);
        ReactGA4.send({hitType: "pageview", page: history.location.pathname + history.location.search});
    })

    if (isAuthenticated && !isDevelopment) {
        const value = {
            email: props.auth.user.email,
            givenName: props.auth.user.firstname,
            imageUrl: props.auth.user.profilePicture,
        }
        setCookie('cdp-cookie', JSON.stringify(value), 7);
    }

    const RedirectTo = (props: any) => (isAuthenticated) ? <Redirect to="/create-user"/> : <SignIn {...props} />;


    return (
        <div>
            <Route
                exact={true}
                path="/"
                render={renderProps => RedirectTo(renderProps)}
            />

            <Route
                exact={true}
                path="/login"
                component={LoginForm}
            />

          <PrivateRoute
                    {...defaultProtectedRouteProps}
                    path="/update-user"
                    component={OpenDentalUsers}
                />

                <PrivateRoute
                    {...defaultProtectedRouteProps}
                    path="/create-user"
                    component={CreateOpenDentalUser}
                />
            <PrivateRoute
                {...defaultProtectedRouteProps}
                path="/usage-report"
                component={UsageReport}
            />
            <PrivateRoute
                {...defaultProtectedRouteProps}
                path="/api-request-module"
                component={ManualApiModule}
            />
            <PrivateRoute
                {...defaultProtectedRouteProps}
                path="/update-bulk-user"
                component={UpdateBulkUser}
            />
            <PrivateRoute
                {...defaultProtectedRouteProps}
                path="/update-bulk-providers"
                component={UpdateBulkProviders}
            />
            <PrivateRoute
                {...defaultProtectedRouteProps}
                path="/od-adjustments"
                component={OdAdjustments}
            />
            <PrivateRoute
                {...defaultProtectedRouteProps}
                path="/od-payment-types"
                component={OdPaymentTypes}
            />
            <PrivateRoute
                {...defaultProtectedRouteProps}
                path="/fee-schedules"
                component={OdFeeSchedules}
            />
            <PrivateRoute
                {...defaultProtectedRouteProps}
                path="/ins-plans-ucr"
                component={OdInsPlansUcr}
            />
            <PrivateRoute
                {...defaultProtectedRouteProps}
                path="/reset-password"
                component={ResetPassword}
            />





        </div>
    );
}

export default AppRoutes;
